// Phone-Mobile Regular Expression
export const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
export const phoneRegExp1 = /^\+(?:[0-9] ?){6,14}[0-9]$/;
export const phoneRegExp2 = /^\+1\d{10}$/; ///^\+?\d{10,}$/;
export const mobileRegExp = /^\+[1-9]{1}[0-9]{3,14}$/
export const mobileRegExpUS = /^(\()?([0-9]{3})([\)-\.])?([0-9]{3})([-\.])?([0-9]{4})$/; // US Mobile Number (10 digits with optional parentheses and hyphens)
export const telephoneRegExpUS = /^(\d{3}-?\d{3}-?\d{4})$/; // US Telephone Number (10 digits with optional hyphens)

// URL Regular Expression
export const urlRegExp = /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/;

// Email Regular expression
export const emailRegExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

// Zip/Pin Code Regular Expression
export const zipRegExp = /^\d{5}(?:[-\s]\d{4})?$/

// Name String Regular Expression
export const nameRegExp = /^(?![ ]+$)[a-zA-ZàáâäãấåąčćęèéêëėễįìíîïłńòóôöõőøùúûüųūũűÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕŐØÙÚÛÜŲŪŰŸÝŻŹÑßÇŒÆČŠŽ∂ð,.'-]+$/;
export const cityNameRegExp = /^(?![ ]+$)[a-zA-ZàáâäãấåąčćęèéêëėễįìíîïłńòóôöõőøùúûüųūũűÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕŐØÙÚÛÜŲŪŰŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/;
// /^[a-zA-ZàáâäãấåąčćęèéêëėễįìíîïłńòóôöõőøùúûüųūũűÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕŐØÙÚÛÜŲŪŰŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/;

// Gender Validation Regular Expression
export const genderRegExp = /^(male|female|other)$/i;

// Relationship Validation Regular Expression
export const relationshipRegExp = /^(mother|father|guardian|other)$/i;

// Date format Regular Expression
export const dateFormatRegExp = /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[0-2])-\d{4}$/;

// US State Code Regular Expression
export const USStateRegExp = /^(AL|AK|AS|AZ|AR|CA|CO|CT|DE|DC|FM|FL|GA|GU|HI|ID|IL|IN|IA|KS|KY|LA|ME|MH|MD|MA|MI|MN|MS|MO|MT|NE|NV|NH|NJ|NM|NY|NC|ND|MP|OH|OK|OR|PW|PA|PR|RI|SC|SD|TN|TX|UT|VT|VI|VA|WA|WV|WI|WY)$/